module.exports = __webpack_public_path__ + "img/lbyc7.d89334f3.png";